import { useEffect, useState } from 'react'
import adminCss from './sass/adminpage.module.scss'

import { formatMoney } from 'services/util'
import {getAuctionStatus} from '../util/dateString'

export default function StatPaidSummary({auction}) {

  const [totalPaid, setTotalPaid] = useState(0)
  const [totalUnpaid, setTotalUnpaid] = useState(0)

  const [showSummary, setShowSummary] = useState(false)


  //use effect for item/bid calculations
  useEffect(() => {
      if (!auction) {
        setTotalPaid(0)
        setTotalUnpaid(0)
        return
      }

      let paidTotal = 0
      let unpaidTotal = 0

      const items = auction.Items || []
      for (let i = 0; i < items.length; i++) {
        const item = items[i]
        const currentBid = Number(item?.CurrentBid) || 0

        if (item?.Paid === true) paidTotal += currentBid
        else unpaidTotal += currentBid
      }

      const registrations = auction.Registrations || []
      for (let i = 0; i < registrations.length; i++) {
        const registration = registrations[i]
        const donationTotal = Number(registration?.DonationTotal) || 0

        if (donationTotal <= 0) continue

        const donationPayment = registration?.DonationPayment
        const hasDonationPayment = typeof donationPayment === 'string'
          ? donationPayment.trim().length > 0
          : Boolean(donationPayment)

        if (hasDonationPayment) paidTotal += donationTotal
        else unpaidTotal += donationTotal
      }

      const fixedItems = auction.FixedItems || []
      for (let i = 0; i < fixedItems.length; i++) {
        const fixedItem = fixedItems[i]
        const purchasePrice = Number(fixedItem?.PurchasePrice) || 0

        let purchasedCount = 0
        const purchases = fixedItem?.Purchases || []
        for (let j = 0; j < purchases.length; j++) {
          purchasedCount += Number(purchases[j]?.Quantity) || 0
        }

        let paymentCount = 0
        const payments = fixedItem?.Payments || []
        for (let j = 0; j < payments.length; j++) {
          paymentCount += Number(payments[j]?.Quantity) || 0
        }

        paidTotal += paymentCount * purchasePrice

        if (purchasedCount > paymentCount) {
          unpaidTotal += (purchasedCount - paymentCount) * purchasePrice
        }
      }

      setTotalPaid(paidTotal)
      setTotalUnpaid(unpaidTotal)
    }, [auction])

  // use effect for if the summary should show
  useEffect(() => {

    if (auction) {
      const isEnded = getAuctionStatus(auction.StartTime, auction.EndTime)
      const isPreview = auction.Status === 'PREVIEW' 
      
      setShowSummary(isEnded && !isPreview)
    }

    }, [auction])

    if (!showSummary) return <></>

  return (
    <div className={adminCss['admin-auction-items-bidcounts']}>
      <p><b>Total Paid:</b> ${formatMoney(totalPaid)}</p>
      <p><b>Total Unpaid:</b> ${formatMoney(totalUnpaid)}</p>
    </div>
  )
}
